import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "opModal inAppNotificationsModal" }
const _hoisted_2 = { class: "midTitle text-center" }
const _hoisted_3 = { class: "inAppNotificationsContainerModalBody text-center mt-2" }
const _hoisted_4 = { class: "mb-4 inAppNotificationsContainer" }
const _hoisted_5 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_6 = { class: "mt-4 mw-700" }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_in_app_notifications = _resolveComponent("in-app-notifications")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_localized_text, {
        localizedKey: "Notifiche",
        text: "Notifiche"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.notifications.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "Nessuna notifica ricevuta",
                text: "Nessuna notifica ricevuta"
              })
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (item) => {
          return (_openBlock(), _createBlock(_component_in_app_notifications, {
            item: item,
            onClicked: ($event: any) => (_ctx.setReadAndClose(item)),
            class: _normalizeClass({ unread: !item.readOn })
          }, null, 8, ["item", "onClicked", "class"]))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.notifications.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "btn btn-block btn-secondary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setAllAsRead && _ctx.setAllAsRead(...args)))
              }, [
                _createElementVNode("span", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Segna tutte come lette",
                    text: "Segna tutte come lette"
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass({ 'mt-2': _ctx.notifications.length > 0 })
        }, [
          _createElementVNode("button", {
            class: "btn btn-block btn-primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
          }, [
            _createElementVNode("span", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Chiudi",
                text: "Chiudi"
              })
            ])
          ])
        ], 2)
      ])
    ])
  ]))
}